import React, { Fragment } from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Excelimport from '../Components/Excelimport'
import Leftbar from '../Components/Sidebar/Leftbar'
function ExcelImport() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          marginLeft: 24,
          marginTop: 24,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <SHeaderbar />
        <div style={{ flex: 1, padding: 0, minHeight: 0 }}>
          <Excelimport />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default ExcelImport
